export const STATUS_TEXT_COLORS = {
  overdue: "#d32f2f",
  expiring: "#f57c00",
  due: "#388e3c",
  upcoming: "#757575",
};

export const STATUS_BACKGROUND_COLORS = {
  overdue: "#ffebee",
  expiring: "#fff3e0",
  due: "#e8f5e9",
  upcoming: "#f5f5f5",
};

export const STATUS_DISPLAY_TEXT = {
  overdue: "Overdue",
  expiring: "Expiring",
  due: "Available",
  upcoming: "Upcoming",
};

export const getStatusColor = (status) => STATUS_TEXT_COLORS[status] || "#757575";
export const getStatusBGColor = (status) => STATUS_BACKGROUND_COLORS[status] || "#f5f5f5";
export const getStatusDisplayText = (status) => STATUS_DISPLAY_TEXT[status] || String(status || "");
export const getStatusBorderColor = (status) => `${getStatusColor(status)}20`;



// WEBPACK FOOTER //
// ./src/components/InspectionSchedule/statusColors.js